
import { Component, Vue } from 'vue-property-decorator'
import AppContainer from '@/components/AppContainer.vue'
import AppHeader from '@/components/AppHeader.vue'

@Component({
    components: {
        AppContainer,
    },
})
export default class App extends Vue {}
